import React from 'react';
import { Link, useLocation } from 'react-router-dom';

interface NavigationProps {
  className?: string;
  role: string | null;  // "Admin" | "Manager" | "User"
}

const Navigation: React.FC<NavigationProps> = ({ className = '', role }) => {
  const location = useLocation();
  const currentPath = location.pathname;

  const isAdmin = role === "Admin";
  const isManager = role === "Manager";

  return (
    <nav className={`main-navigation ${className}`}>
      <ul className="nav-list">

        {/* Always visible for Admin & Manager */}
        {(isAdmin || isManager) && (
          <li className="nav-item">
            <Link
              to="/"
              className={`nav-link ${currentPath === '/' ? 'active' : ''}`}
            >
              Space Ops
            </Link>
          </li>
        )}

        {/* Admin-only routes */}
        {isAdmin && (
          <>
            <li className="nav-item">
              <Link
                to="/gatherings"
                className={`nav-link ${currentPath === '/gatherings' ? 'active' : ''}`}
              >
                Gatherings
              </Link>
            </li>

            <li className="nav-item">
              <Link
                to="/users"
                className={`nav-link ${currentPath === '/users' ? 'active' : ''}`}
              >
                Users
              </Link>
            </li>
          </>
        )}

        {/* Check-Ins accessible for both Admin + Manager */}
        {(isAdmin || isManager) && (
          <li className="nav-item">
            <Link
              to="/check-ins"
              className={`nav-link ${currentPath === '/check-ins' ? 'active' : ''}`}
              >
              Check-Ins
            </Link>
          </li>
        )}

        {/* CaaS - Admin only */}
        {isAdmin && (
          <li className="nav-item">
            <Link
              to="/caas/clients"
              className={`nav-link ${currentPath.startsWith('/caas') ? 'active' : ''}`}
            >
              CaaS
            </Link>
          </li>
        )}

      </ul>
    </nav>
  );
};

export default Navigation;
